import React from 'react';
import PropTypes, { InferProps } from 'prop-types';

import TabInterface from '@COMPONENTS/SHARED/TabInterface';
import {
    useGetAppSettingsQuery,
    useGetDocumentSettingsQuery,
} from '@SERVICES';
import AppSettingsTab from '../AppSettingsTab';
import DocumentSettingsTab from '../DocumentSettingsTab';
import {
    BrandsTab,
    RegionsTab,
    CountriesTab,
    AreasTab,
    ContractTypesTab,
} from '../EntityManagementTabs';

function EnhancedContent() {
    // Use the new separated APIs directly
    const { data: appSettings, isLoading: appLoading } = useGetAppSettingsQuery();
    const { data: documentSettings, isLoading: docLoading } = useGetDocumentSettingsQuery();

    // Show loading while either API is loading
    if (appLoading || docLoading) {
        return <div>Loading settings...</div>;
    }

    // Don't render if data is not available
    if (!appSettings || !documentSettings) {
        return <div>Unable to load settings. Please try again.</div>;
    }

    const tabs = [
        {
            id: 'app-settings',
            label: 'App Settings',
            content: <AppSettingsTab appSettingsData={appSettings} />,
        },
        {
            id: 'document-settings',
            label: 'Document Settings',
            content: <DocumentSettingsTab documentSettingsData={documentSettings} />,
        },
        {
            id: 'brands',
            label: 'Brands',
            content: <BrandsTab />,
        },
        {
            id: 'regions',
            label: 'Regions',
            content: <RegionsTab />,
        },
        {
            id: 'countries',
            label: 'Countries',
            content: <CountriesTab />,
        },
        {
            id: 'areas',
            label: 'Areas',
            content: <AreasTab />,
        },
        {
            id: 'contract-types',
            label: 'Contract Types',
            content: <ContractTypesTab />,
        },
    ];

    return (
        <TabInterface
            tabs={tabs}
            defaultTab="app-settings"
        />
    );
}

export default EnhancedContent;
